import { Injectable } from "@angular/core";
import { VideoEventCode } from "../enums/VideoEventCode";
import { VideoEventRisk } from "../enums/VideoEventRisk";
import { VideoReviewStatus } from "../enums/VideoReviewStatus.enum";
import { VideoStatus } from "../enums/VideoStatus";
import { IVideoEntry } from "../models/IVideoEntry";
import { VideoEventCodeGroups } from "../utils/video-event-code-groups";


@Injectable({
    providedIn: 'root'
})
export class VideoEventCodeService {
    getEventRisk(eventCode: VideoEventCode): VideoEventRisk {
        if (VideoEventCodeGroups.lowRiskCodes.includes(eventCode)) {
            return VideoEventRisk.Low;
        }
        if (VideoEventCodeGroups.mediumRiskCodes.includes(eventCode)) {
            return VideoEventRisk.Medium;
        }
        if (VideoEventCodeGroups.highRiskCodes.includes(eventCode)) {
            return VideoEventRisk.High;
        }
        if (VideoEventCodeGroups.urgentRiskCodes.includes(eventCode)) {
            return VideoEventRisk.Urgent;
        }

        return VideoEventRisk.None;
    }

    isDmsEvent(eventCode: VideoEventCode): boolean {
        return VideoEventCodeGroups.dmsEventCodes.includes(eventCode)
    }

    isAdasEvent(eventCode: VideoEventCode) {
        return VideoEventCodeGroups.adasEventCodes.includes(eventCode)
    }

    isMinorEvent(videoEvent: IVideoEntry): boolean {
        if (videoEvent.Status === VideoStatus.Downloaded) {
            return false;
        }

        if (videoEvent.reviewStatus !== VideoReviewStatus.NeedsReview) {
            return false;
        }

        switch (videoEvent.EventCode) {
            case VideoEventCode.LowShock:
            case VideoEventCode.MediumShock:
            case VideoEventCode.Unknown:
                return true;
        }

        return false;
    }
}